import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import SettingsShell from './SettingsShell.vue';
import { routes as captainRoutes } from '../captain/captain.routes';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';

export default {
  routes: [
    ...reports.routes,
    {
      path: frontendURL('accounts/:accountId/settings'),
      component: SettingsShell,
      meta: { settingsSection: true },
      children: [
        {
          path: frontendURL('accounts/:accountId/settings'),
          name: 'settings_home',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS, 'custom_role'],
          },
          redirect: to => ({
            name: 'profile_settings_index',
            params: to.params,
          }),
        },
        ...account.routes,
        ...billing.routes,
        ...captainRoutes,
        ...agent.routes,
        ...assignmentPolicy.routes,
        ...agentBot.routes,
        ...attributes.routes,
        ...automation.routes,
        ...auditlogs.routes,
        ...canned.routes,
        ...inbox.routes,
        ...integrations.routes,
        ...labels.routes,
        ...macros.routes,
        ...sla.routes,
        ...teams.routes,
        ...customRoles.routes,
        ...profile.routes,
        ...security.routes,
      ],
    },
  ],
};
